import PropTypes from 'prop-types';
import {useState} from 'react';

import {LOAD_BAR} from '../../../constants/loadBar';
import {RECAPTCHA_ACTIONS} from '../../../constants/recaptcha';
import {PSR_TYPES} from '../../../constants/typesMessages';
import {useRecaptchaProtection} from '../../../hooks/useRecaptchaProtection';
import {sendPsrs} from '../../../services/Api';
import {nextStep, prepareListPsrSelected} from '../../../services/psr';
import {HideButtonWhenLogout} from '../../../shared/components/HideButtonWhenLogout';
import {useChatStore} from '../../../store/slices/chatStore';
import {useEcStore} from '../../../store/slices/ecStore';
import {useInteractionStore} from '../../../store/slices/interactionStore';
import {usePsrStore} from '../../../store/slices/psrStore';

export const MessageQuestionPsrCodeConfirm = (props) => {
  const ecStateId = useEcStore((state) => state.ec.id);
  const [showButtons, setShowButtons] = useState(true);
  const listCodePsr = useChatStore((state) => state.listCodePsr);
  const psrPaymentType = usePsrStore((state) => state.psrPaymentType);
  const setPsrCodePhysical = usePsrStore((state) => state.setPsrCodePhysical);
  const setPsrCodeEcommerce = usePsrStore((state) => state.setPsrCodeEcommerce);
  const setPsrsSelected = usePsrStore((state) => state.setPsrsSelected);
  const sendMessage = useChatStore((state) => state.sendMessage);
  const setMessages = useChatStore((state) => state.setMessages);
  const setChatInputCode = useChatStore((state) => state.setChatInputCode);
  const setChaListCode = useChatStore((state) => state.setChaListCode);
  const setPsrInputOwnerId = useChatStore((state) => state.setPsrInputOwnerId);
  const setChatStageFlow = useChatStore((state) => state.setChatStageFlow);
  const responseFlowChange = useChatStore((state) => state.responseFlowChange);
  const responseTypeChange = useChatStore((state) => state.responseTypeChange);
  const updateEc = useEcStore((state) => state.updateEc);
  const setDotTyping = useInteractionStore((state) => state.setDotTyping);
  const {executeWithProtection} = useRecaptchaProtection();

  const isCorretct = () => {
    setShowButtons(false);
    setPsrInputOwnerId(null);
    setPsrCodePhysical(listCodePsr);
    sendMessage({text: 'Sim', type: 'message-sent'});

    if (psrPaymentType.ecommerce) {
      setChatInputCode([]);
      setChaListCode([]);
      sendMessage({type: PSR_TYPES.PSR_ECOMMERCE});
      return;
    }

    let psrList = prepareListPsrSelected(listCodePsr);
    setDotTyping(true);
    executeWithProtection(
      (payload, token) => sendPsrs(ecStateId, payload, token),
      RECAPTCHA_ACTIONS.DATA_UPDATE,
      psrList
    )
      .then((response) => {
        let result = nextStep(listCodePsr);

        setDotTyping(false);
        updateEc(response.data);
        setChatStageFlow(LOAD_BAR.PSRS);
        responseFlowChange('set-name-bank');
        responseTypeChange('flow-bank');
        setMessages(result.messages);
        setPsrsSelected(psrList.map((psrItem) => psrItem.psr));
      })
      .catch(() => {
        setDotTyping(false);
        setChatInputCode([]);
        setChaListCode([]);
        setPsrCodeEcommerce([]);
        setPsrCodePhysical([]);
        setPsrsSelected([]);
        setMessages([
          {text: 'Ops, algo deu errado :(', type: 'message-receive'},
          {
            text: 'Por favor, verifique os maquininhas escolhidas e tente novamente.',
            type: 'message-receive'
          },
          {type: PSR_TYPES.PSR_PAYMENT}
        ]);
      });
  };

  const isIncorretct = () => {
    setShowButtons(false);
    setPsrInputOwnerId(null);
    setChatInputCode([]);
    setChaListCode([]);
    setMessages([
      {text: 'Não', type: 'message-sent'},
      {
        type: PSR_TYPES.PSR_PHYSICAL
      }
    ]);
  };

  return (
    <div>
      <div className="message-line">
        <div
          className="message-receive"
          id={`msg-${props.question.id}`}
          data-aut-test="message-receive-text"
          data-testid="message-receive-text"
        >
          <div className="message-div">
            <strong>{props.question.text}</strong>
          </div>
        </div>
      </div>
      <HideButtonWhenLogout>
        <>
          {showButtons && (
            <div
              className="message-line"
              data-aut-test="button-option-test-psr"
              data-testid="button-option-test-psr"
            >
              <div className="div-button">
                <button
                  type="button"
                  data-testid="no"
                  onClick={() => isIncorretct()}
                >
                  NÃO
                </button>
                <button
                  type="button"
                  data-testid="yes"
                  onClick={() => isCorretct()}
                >
                  SIM
                </button>
              </div>
            </div>
          )}
        </>
      </HideButtonWhenLogout>
    </div>
  );
};

MessageQuestionPsrCodeConfirm.propTypes = {
  question: PropTypes.object
};
